import { faBell as a, faBuildingColumns as l, faBullhorn as o, faCalendarDays as n, faCheck as r, faCircleArrowDown as e, faCircleArrowUp as i, faCircleExclamation as c, faCirclePlus as f, faCreditCard as t, faDollarSign as d, faDownload as g, faEnvelope as C, faTriangleExclamation as p, faLocationDot as s, faLock as u, faPen as w, faPiggyBank as m, faPrint as D, faQuestion as k, faSeedling as h } from "@fortawesome/pro-solid-svg-icons";
const P = {
  bell: a,
  buildingColumns: l,
  bullhorn: o,
  calendar: n,
  check: r,
  circleArrowDown: e,
  circleArrowUp: i,
  circleExclamation: c,
  circlePlus: f,
  creditCard: t,
  dollarSign: d,
  download: g,
  envelope: C,
  error: p,
  locationDot: s,
  lock: u,
  pen: w,
  piggyBank: m,
  print: D,
  question: k,
  seedling: h
};
export {
  P as headingIconOptions
};
